import create from 'zustand';
import { useRunningTradeStore } from 'global/Datafeed/store/runningTrade';
import {
  RunningTradeCustomFilter,
  RunningTradeStockFilter,
  StockFilterTypeEnum,
} from './types';

interface IFilterStore {
  filter?: RunningTradeCustomFilter;
  stocksFilter?: RunningTradeStockFilter;
}

interface IFilterAction {
  onApplyFilter: (filter: RunningTradeCustomFilter) => void;
  onResetFilter: () => void;
  onApplyStockFilter: (stocksFilter: RunningTradeStockFilter) => void;
}

export const useFilterStore = create<IFilterStore & IFilterAction>((set) => ({
  filter: null,
  stocksFilter: {
    type: StockFilterTypeEnum.AllStock,
    selected: [],
  },
  onApplyFilter: (filter: RunningTradeCustomFilter) => {
    set({
      filter,
    });
    useRunningTradeStore.getState().play('widget');
  },
  onResetFilter: () => {
    set({
      filter: null,
    });
    useRunningTradeStore.getState().play('widget');
  },
  onApplyStockFilter: (activeFilter: RunningTradeStockFilter) => {
    set({
      stocksFilter: activeFilter,
    });
    useRunningTradeStore.getState().play('widget');
  },
}));
